export default "__VITE_ASSET__Dj7QBUXw__"